// eslint-disable-next-line @typescript-eslint/unbound-method
const hasOwn = {}.hasOwnProperty;
export default hasOwn;
